import React, { useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";

const CommonSidebar = ({ iconColor, toggleSidebarMobile }) => {

  const [isCollapsed, setIsCollapsed] = useState(true);
  const [AuthIsCollapsed, setAuthIsCollapsed] = useState(true);


  // x---------------------------------x For Service Slide Collapse x---------------------------------x
  const serviceSlide = () => {
    setIsCollapsed(!isCollapsed);
  };


  // x---------------------------------x For Authentication Slide Collapse x---------------------------------x
  const authSlide = () => {
    setAuthIsCollapsed(!AuthIsCollapsed);
  };

  // x---------------------------------x For Finding URL Location x---------------------------------x
  const location = useLocation();
  const onSameUrl = location.pathname

  // Check if the current URL is root or no specific route is set
  const isDashboardActive = location.pathname === "/" || location.pathname === "/dashboard";

  return (
    <aside
      id="sidebar"
      className="sidebar sticky top-0 left-0 d-lg-block bg-body transition-all duration-500"
      data-bs-theme="none">
      <nav className="navbar py-0">
        {/* x---------------------------------x asidebar top logo  x---------------------------------x */}
        <ul className="list-none mb-2 py-1">
          <li>
            <div className="flex justify-center xl:flex-nowrap flex-wrap items-center my-4 px-2 gap-5">
              <Link to="/" className="flex items-center">
                <svg
                  className="mr-2 text-primary xl:w-[36px] xl:h-[36px]"
                  width="36"
                  height="36"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                  <path d="M3 21l18 0" />
                  <path d="M3 10l18 0" />
                  <path d="M5 6l7 -3l7 3" />
                  <path d="M4 10l0 11" />
                  <path d="M20 10l0 11" />
                  <path d="M8 14l0 3" />
                  <path d="M12 14l0 3" />
                  <path d="M16 14l0 3" />
                </svg>
                <span className="mb-0 mt-1 xl:text-3xl text-xl text-primary font-bold">
                  DashBanker
                </span>
              </Link>
              <button
                className="border-0 xl:mt-0 mt-2 sidebar-toggle-btn p-2 bg-primary-100 lg:hidden block rounded-full ml-1"
                type="button"
                onClick={toggleSidebarMobile}
              >
                <span className="avatar text-dark  flex items-center justify-center">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="1"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="icon svg-stroke  icon-tabler icon-tabler-arrow-right-from-arc"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M15 12H3"></path>
                    <path d="M7 8L3 12l4 4"></path>
                    <path d="M12 21a9 9 0 0 0 0-18"></path>
                  </svg>
                </span>
              </button>
            </div>
          </li>
        </ul>
        {/* x---------------------------------x Nav links x---------------------------------x */}
        <ul className={`list-none mb-4 menu-list w-100 ${iconColor}`}>
          {/* x---------------------------------x Dashboard x---------------------------------x */}
          <li>
            <NavLink
              className={`ps-0 ${isDashboardActive ? "active" : ""}`}
              to="/dashboard"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Dashboard"
              data-bs-original-title="Dashboard"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M5 12l-2 0l9 -9l9 9l-2 0"></path>
                <path d="M5 12v7a2 2 0 0 0 2 2h10a2 2 0 0 0 2 -2v-7"></path>
                <path d="M9 21v-6a2 2 0 0 1 2 -2h2a2 2 0 0 1 2 2v6"></path>
              </svg>
              <span className="mx-3">Dashboard</span>
            </NavLink>
          </li>
          {/* x---------------------------------x Transactions x---------------------------------x */}
          <li>
            <NavLink
              to="transactions"
              className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Transactions"
              data-bs-original-title="Transactions"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M7 10h14l-4 -4"></path>
                <path d="M17 14h-14l4 4"></path>
              </svg>
              <span className="mx-3">Transactions</span>
            </NavLink>
          </li>
          {/* x---------------------------------x Accounts x---------------------------------x */}
          <li>
            <NavLink
              to="accounts"
              className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Accounts"
              data-bs-original-title="Accounts"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
              </svg>
              <span className="mx-3">Accounts</span>
            </NavLink>
          </li>
          {/* x---------------------------------x Investments x---------------------------------x */}
          <li>
            <NavLink
              to="investments"
              className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Investments"
              data-bs-original-title="Investments"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M16 15h5v7l-2.5 -1.5l-2.5 1.5z"></path>
                <path d="M20 11l-8 -8l-9 9h2v7a2 2 0 0 0 2 2h5"></path>
                <path d="M9 21v-6a2 2 0 0 1 2 -2h1.5"></path>
              </svg>
              <span className="mx-3">Investments</span>
            </NavLink>
          </li>
          {/* x---------------------------------x Credit Cards x---------------------------------x */}
          <li>
            <NavLink
              to="credit-cards"
              className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Credit Cards"
              data-bs-original-title="Credit Cards"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M3 5m0 3a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v8a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3z"></path>
                <path d="M3 10l18 0"></path>
                <path d="M7 15l.01 0"></path>
                <path d="M11 15l2 0"></path>
              </svg>
              <span className="mx-3">Credit Cards</span>
            </NavLink>
          </li>
          {/* x---------------------------------x Loans x---------------------------------x */}
          <li>
            <NavLink
              to="loans"
              className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Loans"
              data-bs-original-title="Loans"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M20.876 10.51a9 9 0 1 0 -7.839 10.43"></path>
                <path d="M3.6 9h16.8"></path>
                <path d="M3.6 15h9.9"></path>
                <path d="M11.5 3a17 17 0 0 0 0 18"></path>
                <path d="M12.5 3a16.986 16.986 0 0 1 2.578 9.02"></path>
                <path d="M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5"></path>
                <path d="M19 21v1m0 -8v1"></path>
              </svg>
              <span className="mx-3">Loans</span>
            </NavLink>
          </li>
          {/* x---------------------------------x Service Sub Menu  x---------------------------------x */}
          <li>
            <Link
              to={onSameUrl}
              className="ps-0 py-0 after:content-['▾'] after:text-2xl"
              aria-label="Authentication"
              onClick={serviceSlide}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                <path d="M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4" />
                <path d="M14.5 5.5l4 4" />
                <path d="M12 8l-5 -5l-4 4l5 5" />
                <path d="M7 8l-1.5 1.5" />
                <path d="M16 12l5 5l-4 4l-5 -5" />
                <path d="M16 17l-1.5 1.5" />
              </svg>
              <span className="mx-3">Services</span>
            </Link>
            <ul
              className={`list-unstyled transition-all duration-500 ease-in-out transform overflow-hidden custom_drop_ul
              ${isCollapsed ? 'max-h-0 opacity-0 scale-95' : 'max-h-[500px] opacity-100 scale-100'}`}
              id="services"
            >
              {/* x---------------------------------x Services x---------------------------------x */}
              <li>
                <NavLink
                  to="services"
                  className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Services"
                  data-bs-original-title="Services"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M3 21h4l13 -13a1.5 1.5 0 0 0 -4 -4l-13 13v4"></path>
                    <path d="M14.5 5.5l4 4"></path>
                    <path d="M12 8l-5 -5l-4 4l5 5"></path>
                    <path d="M7 8l-1.5 1.5"></path>
                    <path d="M16 12l5 5l-4 4l-5 -5"></path>
                    <path d="M16 17l-1.5 1.5"></path>
                  </svg>
                  <span className="mx-3">Service</span>
                </NavLink>
              </li>
              {/* x---------------------------------x Business Loan x---------------------------------x */}
              <li className="ms-0">
                <NavLink
                  to="business-loan"
                  className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="business Loan"
                  data-bs-original-title="business Loan"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M16 6m-5 0a5 3 0 1 0 10 0a5 3 0 1 0 -10 0" />
                    <path d="M11 6v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4" />
                    <path d="M11 10v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4" />
                    <path d="M11 14v4c0 1.657 2.239 3 5 3s5 -1.343 5 -3v-4" />
                    <path d="M7 9h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3h-2.5" />
                    <path d="M5 15v1m0 -8v1" />
                  </svg>
                  <span className="mx-3">Business Loan</span>
                </NavLink>
              </li>
              {/* x---------------------------------xSavings Accounts  x---------------------------------x */}
              <li className="ms-0">
                <NavLink
                  to="savings-accounts"
                  className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Savings Accounts"
                  data-bs-original-title="Savings Accounts"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                    <path d="M6 21v-2a4 4 0 0 1 4 -4h2.5"></path>
                    <path d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"></path>
                    <path d="M19 18v.01"></path>
                  </svg>
                  <span className="mx-3">Savings Accounts</span>
                </NavLink>
              </li>
              {/* x---------------------------------x Life Insurance x---------------------------------x */}
              <li className="ms-0">
                <NavLink
                  to="life-Insurance"
                  className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Life Insurance"
                  data-bs-original-title="Life Insurance"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M15 21h-9a3 3 0 0 1 -3 -3v-1h10v2a2 2 0 0 0 4 0v-14a2 2 0 1 1 2 2h-2m2 -4h-11a3 3 0 0 0 -3 3v11" />
                    <path d="M9 7l4 0" />
                    <path d="M9 11l4 0" />
                  </svg>
                  <span className="mx-3">Life Insurance</span>
                </NavLink>
              </li>
              {/* x---------------------------------x Personal Loan x---------------------------------x */}
              <li className="ms-0">
                <NavLink
                  to="/personal-loans"
                  className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Personal Loan "
                  data-bs-original-title="Personal Loan "
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                    <path d="M3 21l18 0" />
                    <path d="M3 10l18 0" />
                    <path d="M5 6l7 -3l7 3" />
                    <path d="M4 10l0 11" />
                    <path d="M20 10l0 11" />
                    <path d="M8 14l0 3" />
                    <path d="M12 14l0 3" />
                    <path d="M16 14l0 3" />
                  </svg>
                  <span className="mx-3">Personal Loan</span>
                </NavLink>
              </li>
            </ul>
          </li>
          {/* x---------------------------------x My Privileges  x---------------------------------x */}
          <li>
            <NavLink
              to="/privileges"
              className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Privileges"
              data-bs-original-title="Privileges"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M3 12h1m8 -9v1m8 8h1m-15.4 -6.4l.7 .7m12.1 -.7l-.7 .7"></path>
                <path d="M9 16a5 5 0 1 1 6 0a3.5 3.5 0 0 0 -1 3a2 2 0 0 1 -4 0a3.5 3.5 0 0 0 -1 -3"></path>
                <path d="M9.7 17l4.6 0"></path>
              </svg>
              <span className="mx-3">My Privileges</span>
            </NavLink>
          </li>
          {/* x---------------------------------x Setting x---------------------------------x */}
          <li>
            <NavLink
              to="setting"
              className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Setting"
              data-bs-original-title="Setting"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
                <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
              </svg>
              <span className="mx-3">Setting</span>
            </NavLink>
          </li>
          {/* x---------------------------------x Authentication x---------------------------------x */}
          <li>
            <Link
              to={onSameUrl}
              className="ps-0 py-0 after:content-['▾'] after:text-2xl"
              onClick={authSlide}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2v-6z"></path>
                <path d="M11 16a1 1 0 1 0 2 0a1 1 0 0 0 -2 0"></path>
                <path d="M8 11v-4a4 4 0 1 1 8 0v4"></path>
              </svg>
              <span className="mx-3">Authentication</span>
            </Link>
            {/* x---------------------------------x Authentication Sub Menu  x---------------------------------x */}
            <ul
              className={`custom_drop_ul list-unstyled transition-all duration-500 ease-in-out transform overflow-hidden
              ${AuthIsCollapsed ? 'max-h-0 opacity-0 scale-95' : 'max-h-[500px] opacity-100 scale-100'}`}
              id="Authentication"
            >
              {/* x---------------------------------x Sign in x---------------------------------x */}
              <li className="ms-0">
                <NavLink
                  to="signin"
                  className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Sign in"
                  data-bs-original-title="Sign in"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                    <path d="M6 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2"></path>
                  </svg>
                  <span className="mx-3">Sign in</span>
                </NavLink>
              </li>
              {/* x---------------------------------x Sign up  x---------------------------------x */}
              <li className="ms-0">
                <NavLink
                  to="signup"
                  className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Sign up"
                  data-bs-original-title="Sign up"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M8 7a4 4 0 1 0 8 0a4 4 0 0 0 -8 0"></path>
                    <path d="M6 21v-2a4 4 0 0 1 4 -4h2.5"></path>
                    <path d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z"></path>
                    <path d="M19 18v.01"></path>
                  </svg>
                  <span className="mx-3">Sign up</span>
                </NavLink>
              </li>
              {/* x---------------------------------x Password reset x---------------------------------x */}
              <li className="ms-0">
                <NavLink
                  to="password-reset"
                  className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Password reset"
                  data-bs-original-title="Password reset"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 13a2 2 0 0 1 2 -2h10a2 2 0 0 1 2 2v6a2 2 0 0 1 -2 2h-10a2 2 0 0 1 -2 -2z"></path>
                    <path d="M8 11v-4a4 4 0 1 1 8 0v4"></path>
                    <path d="M15 16h.01"></path>
                    <path d="M12.01 16h.01"></path>
                    <path d="M9.02 16h.01"></path>
                  </svg>
                  <span className="mx-3">Password reset</span>
                </NavLink>
              </li>
              {/* x---------------------------------x 2-Step Authentication x---------------------------------x */}
              <li className="ms-0">
                <NavLink
                  to="two-step"
                  className={({ isActive }) => (isActive ? "active ps-0" : "ps-0")}
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="2-Step Authentication"
                  data-bs-original-title="2-Step Authentication"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M11.46 20.846a12 12 0 0 1 -7.96 -14.846a12 12 0 0 0 8.5 -3a12 12 0 0 0 8.5 3a12 12 0 0 1 -.09 7.06"></path>
                    <path d="M15 19l2 2l4 -4"></path>
                  </svg>
                  <span className="mx-3">Authentication</span>
                </NavLink>
              </li>
              {/* x---------------------------------x Lockscreen x---------------------------------x */}
              <li className="ms-0">
                <NavLink
                  to="lockscreen"
                  className=" ps-0"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Lockscreen"
                  data-bs-original-title="Lockscreen"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M4 8v-2c0 -.554 .225 -1.055 .588 -1.417"></path>
                    <path d="M4 16v2a2 2 0 0 0 2 2h2"></path>
                    <path d="M16 4h2a2 2 0 0 1 2 2v2"></path>
                    <path d="M16 20h2c.55 0 1.05 -.222 1.41 -.582"></path>
                    <path d="M15 11a1 1 0 0 1 1 1m-.29 3.704a1 1 0 0 1 -.71 .296h-6a1 1 0 0 1 -1 -1v-3a1 1 0 0 1 1 -1h2"></path>
                    <path d="M10 11v-1m1.182 -2.826a2 2 0 0 1 2.818 1.826v1"></path>
                    <path d="M3 3l18 18"></path>
                  </svg>
                  <span className="mx-3">Lockscreen</span>
                </NavLink>
              </li>
              {/* x---------------------------------x Maintenance x---------------------------------x */}
              <li className="ms-0">
                <NavLink
                  to="maintenance"
                  className=" ps-0"
                  data-bs-toggle="tooltip"
                  data-bs-placement="right"
                  aria-label="Maintenance"
                  data-bs-original-title="Maintenance"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="30"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    className="svg-stroke"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                    <path d="M5 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                    <path d="M15 20a2 2 0 1 0 4 0a2 2 0 0 0 -4 0"></path>
                    <path d="M5 20h-2v-6l2 -5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0h-6m-6 -6h15m-6 0v-5"></path>
                    <path d="M3 6l9 -4l9 4"></path>
                  </svg>
                  <span className="mx-3">Maintenance</span>
                </NavLink>
              </li>
            </ul>
          </li>
          {/* x---------------------------------x Documentation x---------------------------------x */}
          <li>
            <NavLink
              to="/docs/documentation"
              className=" ps-0"
              data-bs-toggle="tooltip"
              data-bs-placement="right"
              aria-label="Setting"
              data-bs-original-title="Setting"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="30"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
                className="svg-stroke"
              >
                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                <path d="M10.325 4.317c.426 -1.756 2.924 -1.756 3.35 0a1.724 1.724 0 0 0 2.573 1.066c1.543 -.94 3.31 .826 2.37 2.37a1.724 1.724 0 0 0 1.065 2.572c1.756 .426 1.756 2.924 0 3.35a1.724 1.724 0 0 0 -1.066 2.573c.94 1.543 -.826 3.31 -2.37 2.37a1.724 1.724 0 0 0 -2.572 1.065c-.426 1.756 -2.924 1.756 -3.35 0a1.724 1.724 0 0 0 -2.573 -1.066c-1.543 .94 -3.31 -.826 -2.37 -2.37a1.724 1.724 0 0 0 -1.065 -2.572c-1.756 -.426 -1.756 -2.924 0 -3.35a1.724 1.724 0 0 0 1.066 -2.573c-.94 -1.543 .826 -3.31 2.37 -2.37c1 .608 2.296 .07 2.572 -1.065z"></path>
                <path d="M9 12a3 3 0 1 0 6 0a3 3 0 0 0 -6 0"></path>
              </svg>
              <span className="mx-3">Documentation</span>
            </NavLink>
          </li>
        </ul >
      </nav >
    </aside >
  );
};

export default CommonSidebar;
